module.exports = __webpack_public_path__ + "img/long-arrow-alt-down.50b3cd31.svg";